import { render, staticRenderFns } from "./PartnerDetail.vue?vue&type=template&id=9bd41624&scoped=true&"
import script from "./PartnerDetail.vue?vue&type=script&lang=js&"
export * from "./PartnerDetail.vue?vue&type=script&lang=js&"
import style0 from "./PartnerDetail.vue?vue&type=style&index=0&id=9bd41624&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd41624",
  null
  
)

export default component.exports